import { useEffect } from 'react';
import './Thankyou.scss'
const Thankyou = () => {
    let isTrue = false;
    useEffect(() => {
        if (isTrue === false) {
            isTrue = true;
            const scriptDiv1 = document.createElement('script');
            scriptDiv1.innerHTML = ` {(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MH29QND');}`;
            document.head.appendChild(scriptDiv1);

            const noscript = document.createElement('noscript');
            noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MH29QND"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
            document.body.appendChild(noscript);

        }
    }, []);

    return (
        <div className="tankyou-div">
            <h1>Thank You!</h1>
            <p>感謝提交信息，隨後課程顧問老師會用WhatsApp聯繫您！</p>
            <div className="emoji">😊</div>
            <p>Thank you for submit the information, our consultant teacher will contact by whatsapp soon</p>
            {/* <button class="btn" onclick="window.location.href='index.html'">Go Back Home</button> */}
        </div>
    )
}
export default Thankyou;